<template>
  <div class="book-shelf-detail-wrapper" :class="[MobileClass]">
    <!-- TODO 有时间优化一下 -->
    <div v-if="showCreat" style="width: 100vw;height:200vh;background-color: #fff;position: absolutet;top:0;left: 0"></div>
    <!-- PC端开始 -->
    <div class="book-shelf-detail" v-if="!isMobile">
      <!-- pc-top -->
      <div class="book-top" :class="styleClass">
        <div class="book-top-left">
          <!-- 返回按钮 -->
          <div class="back" @click="goBack('pc')" v-show="$route.query.libId || linkReturn == 1">
            <img :src="backImg" alt="" />
          </div>
          <!-- 搜索栏 -->
          <div class="search-box" :class="styleClass" v-if="displayOrNot.search === 1">
            <img :src="searchImg" alt="" @click="searchClick" />
            <div class="ipt" :class="styleClass">
              <el-input v-model.trim="val" :placeholder="msg" @keyup.native.enter="searchClick" ref="elInput" @focus="msg = ''" @blur="msg = languageOption.searchByTitle"></el-input>
            </div>
          </div>
        </div>
        <div class="book-top-center" v-if="options.length !== 0">
          <el-tooltip class="item" effect="light" :content="language === 1 ? 'Previous collection' : '查看上一个专辑'" placement="left">
            <div class="switch-button switch-button-left" :class="styleClass" @click="goUp"></div>
          </el-tooltip>
          <div class="title-bg" :class="styleClass">
            <el-select v-model="bookshelfName" :popper-class="selectDropdownStyleClass" :popper-append-to-body="true" @change="getData" placeholder="">
              <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
          <el-tooltip class="item" effect="light" :content="language === 1 ? 'Next collection' : '查看下一个专辑'" placement="right">
            <div class="switch-button switch-button-right" :class="styleClass" @click="goDown"></div>
          </el-tooltip>
        </div>
        <div class="book-top-center" v-else>
          <el-tooltip class="item" effect="light" :content="bookshelfName" placement="bottom">
            <div class="title-bg no-select" @click="titleScrolling = !titleScrolling" :class="styleClass">
              <span class="title" :class="{ 'scroll-title': titleLength >= 30 && titleScrolling }">{{ bookshelfName }}</span>
            </div>
          </el-tooltip>
        </div>

        <div class="book-top-right">
          <div v-if="showStyle == 0 && displayOrNot.login === 1">
            <div class="library-login" @click="$router.push({ path: '/personal' })" v-if="isLogin">
              <img src="@imgs/bookshelfdetail/homepage-wood.png" style="top: 7px" /><span>{{ languageOption.myHomepage }}</span>
            </div>
            <div v-else class="library-login" @click="goLogin">
              <img src="@imgs/bookshelfdetail/login-wood.png" /><span>{{ languageOption.loginRegistration }}</span>
            </div>
          </div>
          <div v-if="showStyle == 1 && displayOrNot.login === 1" class="simple">
            <div class="library-login" @click="$router.push({ path: '/personal' })" v-if="isLogin">
              <img src="@imgs/bookshelfdetail/homepage.png" style="top: 8px" /><span>{{ languageOption.myHomepage }}</span>
            </div>
            <div v-else class="library-login" @click="goLogin">
              <img src="@imgs/bookshelfdetail/login-simple.png" /><span>{{ languageOption.loginRegistration }}</span>
            </div>
          </div>
          <div class="share-book" v-if="displayOrNot.share === 1" :class="styleClass" @click="openShareDialog">
            <img class="share-book-img" :src="shareImg" alt="" />
            <span class="share-book-span">{{ languageOption.share }}</span>
          </div>
        </div>

        <share-dilalog ref="share" :language="language" :qrObj="qrObj" :typeName="language === 1 ? 'collection' : '专辑'" :isInset="isInset" />
      </div>
      <!-- pc-center -->
      <div class="book-center" id="bookCenter" ref="bookCenter" :class="styleClass">
        <div class="book-center-left bookContent" :class="styleClass"></div>
        <div class="book-center-content bookContent" :style="{ 'padding-left': (w - BookWidth) / 2 + 'px' }" :class="styleClass">
          <div class="cfbSon" v-for="(item, index) in filterList" :key="index" @click="toGo(item.id, item.readModel, index, item.qrLink)">
            <el-tooltip class="item" effect="dark" :disabled="displayOrNot.pctitle === 1" :content="item.title" placement="top">
              <div class="cfbsone">
                <div class="csbsoneSon">
                  <div class="outer">
                    <div class="img-wrapper">
                      <div class="img-wrapper1">
                        <img v-show="item.showImg" class="imgs" :src="item.coverUrl ? item.coverUrl : require('@/assets/imgs/al_morebook2.png')" />
                        <img v-show="item.showImg" :src="showAdornment(item.adornment)" alt="" class="adornment" />
                        <div class="qr" v-if="displayOrNot.hoverQRcode !== 0">
                          <vue-qr :text="item.qrLink" :size="70" :margin="2" />
                        </div>
                      </div>
                    </div>
                    <div v-show="!item.showImg" class="loading"><img src="../assets/imgs/bookshelfdetail/loading.gif" /></div>
                  </div>
                </div>
              </div>
            </el-tooltip>
            <div class="cfbstwo" v-if="displayOrNot.pctitle === 1">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
        <div class="book-center-right bookContent" :class="styleClass"></div>
      </div>
      <!-- pc-bottom -->
      <div class="book-bottom" :class="styleClass">
        <div class="logo-left" @click="goBookIndex">
          <img :src="logo" alt="" />
        </div>
        <div class="number" v-if="showStyle == 0">
          <div class="">{{ bookshelfList.length }}</div>
        </div>
        <div class="book-bottom-right book-bottom-item" :class="styleClass">
          <div v-if="showStyle === 1 && displayOrNot.collect === 1" class="button-collect button-item simple" :class="{ wider: isCollect }" @click="collect()">
            <img class="collect-button" :src="!isCollect ? require('@imgs/bookshelf/collect-white.png') : require('@imgs/bookshelf/collect-white1.png')" />
            <span>{{ isCollect ? languageOption.collected : languageOption.favorites }}</span>
          </div>
          <div v-else-if="displayOrNot.collect === 1" class="button-collect button-item wood" :class="{ wider: isCollect }" @click="collect()">
            <img class="collect-button" :src="!isCollect ? require('@imgs/bookshelf/collect-wood.png') : require('@imgs/bookshelf/collect-wood1.png')" />
            <span>{{ isCollect ? languageOption.collected : languageOption.favorites }}</span>
          </div>
          <toolbar type="bookShelf" :language="language" :works-id="active_index || decryption_id" :show-style="showStyle" />
          <!-- 问卷 -->
          <div v-if="questionnaire === 1" class="button-questionaire button-item" :class="styleClass" @click="goQuestionaire">
            <img :src="questionnaireImg" /><span>{{ languageOption.questionnaire }}</span>
          </div>
          <div class="sort" :class="styleClass">
            <span class="sort-item name-sort" @click="sort_name_fn" :class="{ 'isActiveName sort-item-active': isActiveName }">{{ languageOption.name }}</span>
            <span class="sort-item timer-sort" @click="sort_time_fn" :class="{ 'isActiveTimer sort-item-active': isActiveTimer }">{{ languageOption.time }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="book-shelf-detail mobile" :class="{ 'wood-background': showStyle != 1 }" v-if="isMobile">
      <!-- mobile-top -->
      <div class="book-top mobile-book-top" :class="styleClass">
        <div class="mobile-book-top-right">
          <img v-show="($route.query.libId && lock) || linkReturn == 1" :src="mobileBackImg" class="mobile-back button-item" @click="goBack('phone')" />
        </div>

        <div v-if="options.length !== 0" class="book-top-center mobile-book-top-center">
          <div class="title-bg" :class="styleClass">
            <el-select v-model="bookshelfName" :popper-class="selectDropdownStyleClass" :popper-append-to-body="true" @change="getData" placeholder="">
              <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
        </div>
        <div v-else class="book-top-center mobile-book-top-center">
          <el-tooltip class="item" effect="light" :content="bookshelfName" placement="bottom">
            <div class="title-bg no-select" :class="styleClass" @click="titleScrolling = !titleScrolling">
              <span class="title" :class="{ 'scroll-title': titleLength >= 20 && titleScrolling }">{{ bookshelfName }}</span>
            </div>
          </el-tooltip>
        </div>
        <div class="mobile-book-top-right" style="justify-content: flex-end;">
          <!--<img
            class="button-item"
            v-if="displayOrNot.collect === 1"
            :src="isCollect ? require('@imgs/personalPage/collect-icon3.png') : require('@imgs/personalPage/collect-icon1.png')"
            @click="collect()"
          />-->
          <template v-if="showStyle == 0 && displayOrNot.login === 1">
            <img class="button-item" v-if="isLogin" src="@imgs/bookshelfdetail/homepage-wood_mobile.png" width="26" @click="$router.push({ path: '/personal' })" alt="我的主页" />
            <img class="button-item" v-else src="@imgs/bookshelfdetail/login-mobile.png" width="26" @click="goLogin" alt="登录" />
          </template>
          <template v-if="showStyle == 1 && displayOrNot.login === 1">
            <img class="button-item" v-if="isLogin" src="@imgs/bookshelfdetail/homepage.png" @click="$router.push({ path: '/personal' })" width="26" alt="我的主页" />
            <img class="button-item" v-else src="@imgs/bookshelfdetail/login-simple-mobile@2x.png" width="26" @click="goLogin" alt="登录" />
          </template>
        </div>
      </div>
      <!-- mobile-center -->
      <div class="book-center mobile-book-center" id="bookMobile" ref="bookMobile" :class="styleClass">
        <div v-if="displayOrNot.search === 1" class="mobile-search" :class="styleClass" @touchend.prevent="showSearchBox">
          <img :src="require(`@imgs/bookshelfdetail/mobile_search_${showStyle}.png`)" />
          <span>{{ languageOption.search }}</span>
        </div>
        <div class="book-center-content mobile-book-center-content bookContent" :class="[styleClass, mobileLarge]">
          <div class="mobile-content-center" :class="mobileLarge">
            <div class="cfbSon" v-for="(item, index) in filterList" :key="index" @click="toGo(item.id, item.readModel, index, item.qrLink)">
              <div class="cfbsone">
                <div class="csbsoneSon">
                  <div class="outer">
                    <div class="img-wrapper">
                      <div class="img-wrapper1">
                        <img v-show="item.showImg" class="imgs" :src="item.coverUrl ? item.coverUrl : require('@/assets/imgs/al_morebook2.png')" />
                        <img v-show="item.showImg" :src="showAdornment(item.adornment)" alt="" class="adornment" />
                      </div>
                    </div>
                    <div v-show="!item.showImg" class="loading"><img src="../assets/imgs/bookshelfdetail/loading.gif" /></div>
                  </div>
                </div>
              </div>
              <div class="cfbstwo">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- mobile-bottom -->
      <div class="book-bottom mobile-book-bottom" :class="[styleClass, { 'big-screen-detail': isBigScreen }]">
        <div class="book-bottom-left book-bottom-item">
          <img :src="logo" class="mobile-book-top-left" @click="goBookIndex" />
          <!--<div v-if="isPoster === 1" class="poster button-item" :class="styleClass" @touchend.prevent="changePosterImg"><img :src="mobileStylePosterImg" /><span>海报</span></div>-->
        </div>
        <div class="number">
          <div v-if="showStyle == 0">{{ filterList.length }}</div>
        </div>
        <div class="book-bottom-right book-bottom-item" style="justify-content: center">
          <template v-if="!(displayOrNot.collect !== 1 && isPoster !== 1 && charge !== 1 && questionnaire !== 1)">
            <img v-if="showStyle == 0" src="@imgs/bookshelfdetail/more.png" alt="更多" @click="showMore = !showMore" />
            <img v-if="showStyle == 1" src="@imgs/bookshelfdetail/more-simple-mobile@2x.png" alt="更多" @click="showMore = !showMore" />
          </template>
          <!--<template v-else-if="isPoster === 1">
            <img v-if="showStyle == 0" src="@imgs/bookshelfdetail/poster@2x.png" alt="海报" @touchend.prevent="changePosterImg" />
            <img v-if="showStyle == 1" src="@imgs/bookshelfdetail/poster-simple-mobile.png" alt="海报" @touchend.prevent="changePosterImg" />
          </template>
          <template v-else-if="questionnaire === 1">
            <img v-if="showStyle == 0" src="@imgs/bookshelfdetail/questionare@2x.png" alt="问卷" @click="goQuestionaire" />
            <img v-if="showStyle == 1" src="@imgs/bookshelfdetail/questionare-simple-mobile@2x.png" alt="问卷" @click="goQuestionaire" />
          </template>
          <toolbar v-else-if="charge === 1" type="bookShelf" :works-id="active_index || decryption_id" :show-style="showStyle" />-->
          <!-- 问卷 -->
          <!--<div v-if="questionnaire === 1" class="button-questionaire button-item" :class="styleClass" @click="goQuestionaire"><img :src="questionnaireImg" /><span>问卷</span></div>-->
        </div>
        <template>
          <ul class="book-bottom-item__more" :class="[styleClass, language === 1 ? 'en' : '']" v-if="showMore">
            <li v-if="displayOrNot.collect === 1" @click="collect()">
              <img class="button-item" :src="isCollect ? require('@imgs/bookshelf/collect-wood1.png') : require('@imgs/bookshelf/collect-wood.png')" />
              <span>{{ isCollect ? languageOption.collected : languageOption.favorites }}</span>
              <el-divider></el-divider>
            </li>
            <li v-if="isPoster === 1" @touchend.prevent="changePosterImg">
              <img src="@imgs/bookshelfdetail/poster@2x.png" alt="海报" />
              <span>{{ languageOption.poster }}</span>
              <el-divider></el-divider>
              <!--<img v-if="showStyle == 1" src="@imgs/bookshelfdetail/poster-simple-mobile.png" alt="海报" @touchend.prevent="changePosterImg" />-->
            </li>
            <li v-if="charge === 1">
              <toolbar type="bookShelf" :works-id="active_index || decryption_id" :show-style="showStyle" />
              <el-divider></el-divider>
            </li>
            <li v-if="questionnaire === 1" class="question" @click="goQuestionaire">
              <img src="@imgs/bookshelfdetail/questionare@2x.png" alt="问卷" @click="goQuestionaire" />
              <span>{{ languageOption.questionnaire }}</span>
              <!--<img v-if="showStyle == 1" src="@imgs/bookshelfdetail/questionare-simple-mobile@2x.png" alt="问卷" @click="goQuestionaire" />-->
            </li>
            <img
              :src="showStyle === 1 ? require('@imgs/bookshelfdetail/sub-arrow.png') : require('@imgs/bookshelfdetail/sub-arrow-wood.png')"
              style="position: absolute;right: 0; bottom: -6px;width: 10px"
            />
          </ul>
        </template>
      </div>
      <SearchBox
        :showStyle="showStyle"
        ref="searchBox"
        :language="language"
        :searchList="searchBoxList"
        :openMode="$route.query.openMode"
        @searchClick="searchBoxSearch"
        @close="searchBoxClose"
      ></SearchBox>
    </div>
    <!-- 排序的弹窗 -->
    <AZ :sortFlag="sortFlag" ref="az"></AZ>
    <timeDialog :lang="language" :timerFlag="timerFlag" ref="timerSort"></timeDialog>
    <PosterCont :qr-val-prop="posterQr" ref="posterCont" v-if="isMobile"></PosterCont>
    <MobilePosterImg :language="language" :mobilePosterImg="mobilePosterImg" ref="mobilePosterImg"></MobilePosterImg>
    <QuestionaireForm ref="questionaireForm" type="bookShelf"></QuestionaireForm>
  </div>
</template>
<script>
import ShareDilalog from '../components/MyBookshelf/components/ShareDialog'
import AZ from '../components/bookShelfDetail/az'
import timeDialog from '../components/bookShelfDetail/timeDialog'
import VueQr from 'vue-qr'
import { judgeIsMobile, isLogin, getByteLength } from '@/utils'
import SearchBox from '../components/searchBox'
import bookshelfDetail from '@api/bookshelfDetail'
import apis from '@api/getBook'
import { judgeBigScreen } from '@/utils'
import BookShelfInterface from '@api/BookShelf'
import BookLibInterface from '@api/bookLib'
import PosterCont from '@components/poster/mobilePosterCont'
import html2canvas from 'html2canvas'
import MobilePosterImg from '@components/poster/mobilePosterImg'
import { isPureNum } from '@/utils'
import { setEncryption } from '@/utils'
import { preventOverScroll } from '@/phoneUtils'
import getEpubPath from '@api/epub'
import wxSetting from '@components/common/wxSetting'
import QuestionaireForm from '@components/questionnaire'
import { mapState } from 'vuex'
import homeApi from '@api/home'
import chargeApi from '@api/chargeManager'
import Toolbar from '@components/toolbar/toolbar.vue'
import login from '@api/login'
export default {
  name: 'bookShelfDetail',
  mixins: [wxSetting],
  data() {
    return {
      showCreat: true,
      showStyle: 0, // 0 木纹 1 简约
      typeName: '专辑',
      options: [],
      value: '',
      searchValue: '',
      msg: '',
      qrObj: {
        type: 'bookShelf',
        value: '',
        iframeUrl: ''
      },
      cover: '',
      bookshelfName: '',
      bookshelfList: [],
      filterList: [],
      searchList: [],
      BhList: [],
      val: '',
      jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo'],
      startPage: 0,
      endPage: 20,
      currentPage: 1, //初始页
      totalCount: 0, //总数量
      BookHeight: 0,
      BookWidth: 0,
      sortFlag: false, //按照名称升序还是降序
      timerFlag: false, //按照时间升序还是降序
      itemList: [],
      w: null,
      bWidth: 0,
      timer: null,
      newTimer: null,
      hc: null,
      searchBoxList: [],
      isBigScreen: false,
      hotSrc: require('@/assets/imgs/hotAlLib2.png'),
      newSrc: require('@/assets/imgs/newAlLib2.png'),
      isActiveName: false, //是否点击排序
      isActiveTimer: false,
      active_index: '', //当前专辑id
      lock: true,
      // alLibPoster: require('@imgs/alLibPoster.png'),
      mobilePosterImg: '',
      posterQr: window.location.href,
      logoUrl: '',
      linkJump: '',
      logo: '',
      isPoster: 0,
      decryption_id: isPureNum(this.$route.query.id),
      shareUrl: '',
      isStreaming: false,
      isInset: false,
      simpleBriefNum: 3,
      loginUrl: window.PROJECT_CONFIG.BASE_URL,
      showMore: false,
      isCollect: false,
      needPay: true,
      collectId: 0,
      titleScrolling: true
    }
  },
  computed: {
    ...mapState('config', {
      charge: (state) => state.bookShelfObj.charge,
      questionnaire: (state) => state.bookShelfObj.questionnaire,
      questionType: (state) => state.bookShelfObj.questionType,
      questionContentLink: (state) => state.bookShelfObj.questionContentLink
    }),
    isMobile() {
      return this.$store.state.book.isMobile
    },
    isLogin() {
      return this.$store.state.common.isLogin
    },
    MobileClass() {
      return this.isMobile ? 'books-mobile' : ''
    },
    userName() {
      return localStorage.getItem('username')
    },
    albumData() {
      return this.$store.state.config.bookShelfObj.albumData
    },
    displayOrNot() {
      return this.$store.state.config.bookShelfObj.displayOrNot
    },
    shrinkImgHei() {
      if (item.coverWidth / item.coverHeight > 1.34) {
        return (item.coverHeight / item.coverWidth) * 167 + 'px'
      } else {
        return 'auto'
      }
    },
    styleYldzNum() {
      return parseInt(this.filterList.length / 5)
    },
    yldzNum() {
      return parseInt(this.filterList.length / 2)
    },
    yldzNumSj() {
      if (parseInt(this.filterList.length / 2) == 0) {
        return 3
      } else if (parseInt(this.filterList.length / 2) == 1) {
        return 3
      } else if (parseInt(this.filterList.length / 2) == 2) {
        return 3
      } else {
        return parseInt(this.filterList.length / 2)
      }
    },
    linkReturn() {
      return this.$route.query.linkReturn
    },
    phonebackWidth() {
      return this.w * 0.96
    },
    phoneBack() {
      return (this.phonebackWidth - 300) / 2
    },
    style0Select() {
      return (this.w - 264.15) / 2
    },
    bookCaseJump() {
      return this.$store.state.config.bookCaseJump
    },
    style1PhoneBookbg() {
      if (Math.ceil(this.filterList.length / 2) == 0) {
        return 3
      } else if (Math.ceil(this.filterList.length / 2) == 1) {
        return 2
      } else if (Math.ceil(this.filterList.length / 2) == 2) {
        return 1
      } else {
        return 0
      }
    },
    topNums() {
      if (Math.ceil(this.filterList.length / 2) == 3) {
        return 561 + 187 + 20
      } else if (Math.ceil(this.filterList.length / 2) == 2) {
        return 561
      } else if (Math.ceil(this.filterList.length / 2) == 1) {
        return 374
      } else if (Math.ceil(this.filterList.length / 2) == 0) {
        return 187
      } else {
        return 0
      }
    },
    styleClass() {
      let className = ''
      switch (this.showStyle) {
        case 0:
          className = 'wood'
          break
        case 1:
          className = 'simple'
          break
        default:
          className = ''
      }
      return className
    },
    mobileLarge() {
      let w = document.documentElement.clientWidth
      if (w >= 1600) {
        return 'mobile-large'
      } else if (w <= 600) {
        return 'mobile-normal'
      } else {
        return 'mobile-medium'
      }
    },
    isMobileLarge() {
      return document.documentElement.clientWidth >= 600
    },
    selectDropdownStyleClass() {
      let className = 'shelfSelectDropdown'
      switch (this.showStyle) {
        case 0:
          className = 'shelfSelectDropdown'
          break
        case 1:
          className = 'shelfSelectDropdownSimple'
          break
        default:
          className = 'shelfSelectDropdown'
      }
      return className
    },
    backImg() {
      return require(`../assets/imgs/bookshelfdetail/back_${this.showStyle}.png`)
    },
    searchImg() {
      return require(`../assets/imgs/bookshelfdetail/search_${this.showStyle}.png`)
    },
    shareImg() {
      return require(`../assets/imgs/bookshelfdetail/share_${this.showStyle}.png`)
    },
    questionnaireImg() {
      return require(`../assets/imgs/bookshelfdetail/button_questionnaire_${this.showStyle}.png`)
    },
    mobileBackImg() {
      return require(`../assets/imgs/bookshelfdetail/mobile_back_${this.showStyle}.png`)
    },
    mobileStylePosterImg() {
      return require(`../assets/imgs/bookshelfdetail/mobile_poster_${this.showStyle}.png`)
    },
    language() {
      return this.$store.state.config.bookShelfObj.language
    },
    noShelfTip() {
      return this.language === 1 ? 'There are no collection available for viewing' : '没有可查看的专辑'
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.language]
    },
    titleLength() {
      return getByteLength(this.bookshelfName)
    }
  },
  components: {
    VueQr,
    ShareDilalog,
    AZ,
    timeDialog,
    SearchBox,
    PosterCont,
    MobilePosterImg,
    QuestionaireForm,
    Toolbar
  },
  watch: {
    val(newName) {
      if (newName == '') {
        this.filterList = this.bookshelfList
      }
    }
  },
  created() {
    login.login().then((res) => {
      if (res && res.data && res.status === 200) {
        let data = res.data
        if (data.code === 101) {
          this.$store.commit('common/UPDATE_IS_LOGIN', false)
        } else if (data.data.username) {
          this.$store.commit('common/UPDATE_IS_LOGIN', true)
          localStorage.setItem('username', data.data.username)
        }
      }
    })
    if (this.isMobile && this.getSearchString('libId')) {
      let libId = this.getSearchString('libId')
      this.getLibData(libId)
    } else if (this.albumData.length == 0) {
      this.options = []
    } else {
      this.options = this.albumData
    }
    if (this.getSearchString('curAdr') && this.isMobile) {
      this.lock = false
    }
    this.$store.commit('book/UPDATE_IS_MOBILE', judgeIsMobile())
    this.getData().then(this.init)
    document.body.style.minWidth = 'auto'
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (to.path == '/list') {
      let componentManager = 'Published'
      this.$store.commit('manage/UPDATE_COMPONENTMANAGER', componentManager)
      let siderBarIndex = 1
      this.$store.commit('manage/UPDATE_SIDEBAR_SUBINDEX', siderBarIndex)
    }
    next()
  },
  async mounted() {
    let _this = this
    window.onresize = function() {
      let dom = document.getElementById('bookMobile')
      if (dom != null) {
        if (dom.scrollTop > 0) {
          dom.scrollTop = 0
        }
      }
      _this.init()
    }
    this.shareUrl = window.location.href.split('#')[0]
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      const wxParams = {
        id: this.decryption_id,
        currentUrl: this.shareUrl
      }
      this.getWXConfig(wxParams, apis.getAlbumWXConfig)
    } else {
      console.log('不是微信浏览器')
    }
    if (judgeBigScreen()) {
      this.isBigScreen = true
      this.$store.commit('book/UPDATE_IS_BIG_SCREEN', true)
    }
    await setTimeout(() => {
      this.showCreat = false
    }, 1000)
  },
  destroyed() {
    window.onresize = null
    this.$store.commit('common/UPDATE_GOODS_OBJS', {
      period: 0,
      creator: '',
      chargeBook: '',
      worksName: '',
      chargePage: 0,
      worksId: '',
      price: '',
      cover: '',
      worksType: '',
      secret: 0,
      trialPercent: 0,
      trialOption: 0,
      articlePrice: ''
    })
    this.$store.commit('config/UPDATE_DISPLAY_OR_NOT_SHELF', { type: 'bookShelfObj', displayOrNot: { login: 1, collect: 1, search: 1, share: 1, pctitle: 0, hoverQRcode: 1 } })
  },
  activated() {},
  methods: {
    init() {
      this.$nextTick(() => {
        //页面可视区宽高
        let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        this.w = this.isMobile ? (this.isMobileLarge ? w - 320 : 304) : w - 240
        if (this.isMobile) {
          this.bWidth = 152 //书的宽度
          this.hc = this.$refs.bookMobile || document.getElementById('bookMobile')
        } else {
          this.bWidth = 170
          this.hc = this.$refs.bookCenter || document.getElementById('bookCenter')
        }
        if (navigator.userAgent.indexOf('iPhone') > -1) {
          preventOverScroll(document.getElementById('bookMobile'))
        }
        //中间区域的高度
        let h = this.hc.offsetHeight
        //计算一行有多少本书
        let BookLength = Math.floor(this.w / this.bWidth)
        //计算有多少行
        let trs = Math.ceil(this.bookshelfList.length / Math.floor(this.w / this.bWidth))
        //简约书架行数
        if (trs <= 4) {
          this.simpleBriefNum = 3
        } else {
          this.simpleBriefNum = trs - 1
        }
        // //动态计算高度
        this.BookHeight = Math.ceil(trs * 204)
        this.BookHeight = this.BookHeight < 204 * Math.ceil(h / 204) ? 204 * Math.ceil(h / 204) : this.BookHeight
        this.BookWidth = BookLength * this.bWidth
        // $('.clear').css({ width: this.BookWidth })
        // $('.clear-sj').css({ width: this.BookWidth, margin: '0 auto' })
        // $('.bookboxs').css({ height: this.BookHeight })
        // $('.bookboxs-sj').css({ height: this.BookHeight })

        $('.bookContent').css({ height: this.BookHeight })
      })
    },
    async toGo(id, readModel, index, qrLink) {
      if (this.charge === 1 && !this.isLogin) {
        this.goLogin()
        return
      }
      this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'catalog')
      const encryption_id = setEncryption(id)
      let openMode = this.$route.query.openMode
      let readModelUrl = qrLink
      if (readModel == 1) {
        const rearSharp = /#*$/
        readModelUrl = `${qrLink}&returnPath=${window.encodeURIComponent(window.location.href.replace(rearSharp, ''))}`
      }
      if (openMode == 0 || this.isMobile) {
        if (readModel == -2) {
          let url = this.filterList[index].url
          if (url.indexOf('?') !== -1) {
            url += '&linkReturn=1'
          } else {
            url += '?linkReturn=1'
          }
          if (url.search('elecPublish/index.html') === -1) {
            window.location.href = url
            return
          } else {
            let exp = new RegExp('(http|https):', 'g')
            url = url.replace(exp, window.location.protocol)
          }

          let ifReload = url.substr(url.indexOf('?', 10)) == '?linkReturn=1'
          window.location.href = url
          this.$store.commit('config/BOOK_CASE_JUMP', url)
          if (!ifReload) {
            // window.location.reload()
          }
        } else if (readModel == 1) {
          window.location.href = readModelUrl
        } else {
          let querys
          if (this.$route.query.forms && this.$route.query.libId) {
            querys = { id: encryption_id, form: 'bookshelfdetai', shelfId: this.active_index || this.decryption_id, forms: 'booklibdetai', libId: this.$route.query.libId, openMode: 0 }
            if (this.$route.query.linkReturn) {
              querys.linkReturn = this.$route.query.linkReturn
            }
          } else {
            querys = { id: encryption_id, form: 'bookshelfdetai', shelfId: this.active_index || this.decryption_id, openMode: 0 }
            if (this.$route.query.linkReturn) {
              querys.linkReturn = this.$route.query.linkReturn
            }
          }
          if (this.charge === 1 && this.$store.state.common.goodsObj.chargePage > 0) {
            querys.chargePage = this.$store.state.common.goodsObj.chargePage
          }
          this.$router.push({ path: '/content', query: querys })
        }
      } else {
        if (readModel == -2) {
          window.open(this.filterList[index].url, '_blank')
        } else if (readModel == 1) {
          window.open(readModelUrl, '_blank')
        } else {
          let qrLink1 = this.filterList[index].qrLink
          window.open(qrLink1, '_blank')
        }
      }
    },
    getEpubUrl(id) {
      // 跳转阅读器的链接
      const params = {
        epubId: id,
        userId: this.userName
      }
      return getEpubPath.getEpubPath(params)
    },
    getShareLink(item, id, readModel) {
      return new Promise((resolve) => {
        const encryption_id = setEncryption(id)
        let query
        const shelfId = this.active_index || this.$route.query.id
        if (this.$route.query.forms && this.$route.query.libId) {
          query = `/content?id=${encryption_id}&form=bookshelfdetai&shelfId=${shelfId}&forms=booklibdetai&libId=${this.$route.query.libId}`
        } else {
          query = `/content?id=${encryption_id}&form=bookshelfdetai&shelfId=${shelfId}`
        }
        if (readModel === -2) {
          resolve(item.url)
        } else if (readModel !== 1) {
          let url = window.location.origin + '/elecPublish' + query
          resolve(url)
        } else {
          const params = {
            epubId: id
          }
          getEpubPath.getEpubPath(params).then((res) => {
            if (res.status == 200 && res.data && res.data.status == 200) {
              let url = window.PROJECT_CONFIG.BASE_URL + '' + res.data.url
              resolve(url)
            }
          })
        }
      })
    },
    //按照名称排序
    sort_name_fn() {
      this.isActiveName = true
      this.isActiveTimer = false
      clearTimeout(this.timer)
      if (this.$refs.timerSort.newFlag == true) {
        this.$refs.timerSort.newFlag = false
      }
      this.$refs.az.flag = true
      let _this = this
      //升序
      if (_this.sortFlag) {
        clearTimeout(this.timer)
        _this.filterList = _this.bookshelfList.sort((a, b) => {
          return a.title.localeCompare(b.title, 'zh')
        })
        _this.sortFlag = !_this.sortFlag
      } else {
        //降序
        _this.filterList = _this.bookshelfList.sort((a, b) => {
          return b.title.localeCompare(a.title, 'zh')
        })
        _this.sortFlag = !_this.sortFlag
      }
      this.timer = setTimeout(() => {
        this.$refs.az.flag = false
      }, 2000)
    },
    //按照时间排序
    sort_time_fn() {
      this.isActiveName = false
      this.isActiveTimer = true
      clearTimeout(this.newTimer)
      if (this.$refs.az.flag == true) {
        this.$refs.az.flag == false
      }
      this.$refs.timerSort.newFlag = true
      let _this = this
      //升序
      if (_this.timerFlag) {
        clearTimeout(this.newTimer)
        _this.filterList = _this.bookshelfList.sort((a, b) => {
          return a.createTime - b.createTime
        })
        _this.timerFlag = !_this.timerFlag
      } else {
        //降序
        _this.filterList = _this.bookshelfList.sort((a, b) => {
          return b.createTime - a.createTime
        })
        _this.timerFlag = !_this.timerFlag
      }
      this.newTimer = setTimeout(() => {
        this.$refs.timerSort.newFlag = false
      }, 2000)
    },
    //模糊搜索
    searchClick() {
      this.searchList = this.bookshelfList.filter((item) => {
        return item.title.toLowerCase().includes(this.val.toLowerCase())
      })
      this.filterList = this.searchList
    },
    searchBoxSearch(val) {
      this.searchList = this.bookshelfList.filter((item) => {
        return item.title.toLowerCase().includes(val.toLowerCase())
      })
      this.searchBoxList = JSON.parse(JSON.stringify(this.searchList))
    },
    searchBoxClose() {
      this.searchBoxList = []
    },
    //返回
    goBack(type) {
      if (this.bookCaseJump == window.location.href) {
        this.showCreat = true
        setTimeout(function() {
          this.showCreat = false
        }, 500)
      } else if (this.$route.query.linkReturn) {
        window.history.back()
        setTimeout(() => {
          window.location.reload()
        }, 50)
      } else {
        const id = this.$route.query.libId
        this.$router.replace(`/bookLibdetail?id=${id}&openMode=${this.$route.query.openMode}`)
      }
    },
    openShareDialog() {
      this.$refs.share.dialogVisible = true
      this.qrObj.value = window.location.href.replace(`id=${this.$route.query.id}`, `id=${this.active_index || this.decryption_id}`) + '&curAdr=1'
      this.qrObj.iframeUrl = '<iframe src="' + window.location.href + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.title = this.bookshelfName
      this.qrObj.isShowPoster = this.isPoster
    },
    showSearchBox() {
      this.$refs.searchBox.searchFlag = true
    },
    // 获取详情页的数据
    getData(val) {
      let newVal = ''
      if (val && String(val).indexOf('al') != -1) {
        newVal = val.slice(5)
      }
      this.active_index = newVal ? newVal : val
      let params = {
        id: this.active_index || this.decryption_id
      }
      return bookshelfDetail.bookshelfMobileDetail(params).then((res) => {
        if (res && res.data && res.data.code === 0) {
          const data = res.data.data
          this.getCollected(res.data.data.id)
          if (res.data.data.style) {
            this.showStyle = res.data.data.style
          } else {
            this.showStyle = 0
          }
          this.bookshelfName = res.data.data.name
          this.bookshelfList = res.data.data.ebookList
          this.bookshelfList.forEach((item, index) => {
            item.qrLink = ''
          })
          this.filterList = this.bookshelfList
          this.filterList.forEach((item, index) => {
            this.getShareLink(item, item.id, item.readModel).then((url) => {
              item.qrLink = url
              this.$set(this.filterList, index, item)
            })
          })
          // 加载封面图
          this.filterList.forEach((item, index) => {
            this.imgLoading(item.coverUrl, index)
          })
          this.$setDocumentTitle(res.data.data.name)
          if (res.data.data.logo && res.data.data.logo != 'logo.png') {
            this.logo = res.data.data.logo
          } else {
            if (this.isMobile) {
              if (this.showStyle == 0) {
                this.logo = require('@imgs/bookshelfdetail/logo@2x.png')
              } else {
                // logo-lan@2x
                this.logo = require('@imgs/bookshelfdetail/logo-lan@2x.png')
              }
            } else {
              if (this.showStyle == 0) {
                this.logo = require('@imgs/bookshelfdetail/logo@2x.png')
              } else {
                this.logo = require('@imgs/bookshelfdetail/logo-lan@2x.png')
              }
            }
          }
          this.cover = res.data.data.cover
          if (res.data.data.url) {
            this.logoUrl = res.data.data.url
          } else {
            this.logoUrl = `${window.PROJECT_CONFIG.BASE_URL}/elecPublish/index.html`
          }
          this.linkJump = res.data.data.linkJump
          this.isPoster = res.data.data.poster
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksType', value: 'cloud_read_album' })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksId', value: this.active_index || this.decryption_id })

          // 初始化问卷数据
          let bookShelfData = {
            ...data,
            displayOrNot: data.switchGroup ? JSON.parse(data.switchGroup) : { login: 1, collect: 1, search: 1, share: 1, pctitle: 0, hoverQRcode: 1 },
            questionContent: data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(data.questionContent) : {},
            questionContentConstruction: data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(JSON.parse(data.questionContent).construction) : []
          }
          this.$store.commit('config/UPDATE_BOOKSHELFOBJ', bookShelfData)
          if (res.data.data.charge === 1) {
            this.getGoodsInfo(() => {
              this.filterList.forEach((item, index) => {
                item.qrLink = item.qrLink + (this.$store.state.common.goodsObj.chargePage > 0 ? '&chargePage=' + this.$store.state.common.goodsObj.chargePage : '')
                this.$set(this.filterList, index, item)
              })
            })
            this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'cover', value: this.cover || this.filterList[0]?.coverUrl })
          }
          this.init()
          this.msg = this.languageOption.searchByTitle
        }
      })
    },
    imgLoading(src, index) {
      if (src) {
        var img = new Image()
        img.src = src
        img.onload = () => {
          this.filterList[index].showImg = true
          this.$set(this.filterList, index, this.filterList[index])
        }
      } else {
        this.filterList[index].showImg = true
        this.$set(this.filterList, index, this.filterList[index])
      }
    },
    showAdornment(adornment) {
      if (adornment == 'hot.png') {
        return this.hotSrc
      } else if (adornment == 'new.png') {
        return this.newSrc
      } else {
        return adornment
      }
    },
    getAlbumArr(pageNo) {
      let param = {
        pageNo: pageNo,
        pageSize: 11
      }
      let user = ''
      if (this.getSearchString('user')) {
        user = this.getSearchString('user')
      } else {
        user = this.userName
      }
      BookShelfInterface.getMobileBookShelfList(param.pageNo, param.pageSize, user).then((res) => {
        if (res.status == 200 && res.data.page.result) {
          this.options = res.data.page.result
        }
      })
    },
    goUp() {
      let id = this.active_index || this.decryption_id
      if (this.options.length == 0) {
        this.$message({
          showClose: true,
          message: this.noShelfTip,
          type: 'error',
          duration: 2000
        })
        return false
      }
      if (Array.isArray(this.options)) {
        let elementId = ''
        this.options.forEach((element, index) => {
          elementId = String(element.id).indexOf('al') > -1 ? element.id.slice(5) : element.id
          if (elementId == id) {
            if (index == -1) return
            if (this.options[index - 1]) {
              this.bookshelfName = this.options[index - 1].name
              this.getData(this.options[index - 1].id)
            } else {
              this.$message({
                showClose: true,
                message: this.noShelfTip,
                type: 'error',
                duration: 2000
              })
            }
          }
        })
      }
    },
    goDown() {
      let id = this.active_index || this.decryption_id
      if (this.options.length == 0) {
        this.$message({
          showClose: true,
          message: this.noShelfTip,
          type: 'error',
          duration: 2000
        })
        return false
      }
      if (Array.isArray(this.options)) {
        let elementId = ''
        this.options.forEach((element, index) => {
          elementId = String(element.id).indexOf('al') > -1 ? element.id.slice(5) : element.id
          if (elementId == id) {
            if (this.options[index + 1]) {
              this.bookshelfName = this.options[index + 1].name
              this.getData(this.options[index + 1].id)
            } else {
              this.$message({
                showClose: true,
                message: this.noShelfTip,
                type: 'error',
                duration: 2000
              })
            }
          }
        })
      }
    },
    //获取查询字符串信息 url上的作品id和param
    getSearchString(key) {
      // 获取URL中?之后的字符
      var str = window.location.href
      // 以&分隔字符串，获得类似id=123这样的元素数组
      var arr = str.split('&')
      var obj = new Object()
      // 将每一个数组元素以=分隔并赋给obj对象
      for (var i = 0; i < arr.length; i++) {
        var tmp_arr = arr[i].split('=')
        obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1])
      }
      return obj[key]
    },
    getLibData(id) {
      let params = { id }
      return BookLibInterface.getBookLibInfo(params).then((res) => {
        if (res && res.data && res.data.code === 0) {
          // 该图书馆专辑个数数组
          this.options = res.data.data.itemList.filter((item) => {
            return item.id.includes('album')
          })
        }
      })
    },
    goBookIndex() {
      if (this.logoUrl && this.linkJump === 1) {
        window.open(this.logoUrl)
      }
    },
    generatePos() {
      this.$refs.mobilePosterImg.lockPoster = true
    },
    changePosterImg() {
      const curEl = this.$refs.posterCont.$el
      const that = this
      new html2canvas(curEl, {
        backgroundColor: 'transparent',
        allowTaint: false,
        useCORS: true
      }).then((canvas) => {
        // canvas为转换后的Canvas对象
        that.mobilePosterImg = canvas.toDataURL() // 导出图片
        that.$refs.mobilePosterImg.lockPoster = true
      })
    },
    // 问卷展示
    goQuestionaire() {
      if (this.questionType === 0) {
        this.$refs.questionaireForm.visible = true
      } else if (this.questionType === 1) {
        if (this.questionContentLink !== '') {
          window.open(this.questionContentLink, '_blank')
        }
      }
    },
    goLogin() {
      window.location.href = this.loginUrl + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href)
    },
    async collect() {
      await isLogin()
      let param = {
        worksId: this.active_index || this.decryption_id,
        worksType: 'cloud_read_album',
        worksName: this.bookshelfName
      }
      if (this.isCollect) {
        homeApi.cancelCollect({ ids: this.collectId }).then((res) => {
          if (res.data.status === 0) {
            this.$message({
              message: this.languageOption.unsubscribed,
              type: 'success'
            })
            this.isCollect = false
            this.collectId = 0
          }
        })
      } else {
        homeApi.collectWork(param).then((res) => {
          if (res.data.status === 0) {
            this.$message({
              message: this.languageOption.addedToFavorites,
              type: 'success'
            })
            this.isCollect = true
            this.collectId = res.data.data.id
          } else {
            this.$message({
              message: res.data.message || '收藏失败',
              type: 'error'
            })
          }
        })
      }
    },
    getCollected(id) {
      //获取收藏状态
      let param = {
        worksId: id,
        worksType: 'cloud_read_album'
      }
      homeApi.findOneCollect(param).then((res) => {
        if (res.data.status === 0) {
          this.isCollect = true
          this.collectId = res.data.data.id
        } else {
          this.isCollect = false
          this.collectId = 0
        }
      })
    },
    async getGoodsInfo(callback) {
      let param = {
        worksId: this.active_index || this.decryption_id,
        worksType: 'cloud_read_album'
      }
      await chargeApi.getGoodsInfo(param).then((res) => {
        let data = res.data.data
        if (data) {
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'period', value: data.period })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'chargePage', value: data.chargePage || 0 })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'creator', value: data.creator })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'price', value: data.price })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'period', value: data.period })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'worksName', value: data.worksName })
          this.$store.commit('common/UPDATE_GOODS_OBJ', { type: 'secret', value: data.secret })
        }
      })
      callback && callback()
    }
  }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0px !important;
  border-radius: 10px !important;
  background-color: #fed79c !important;
  z-index: 0 !important;
}
.book-shelf-detail-wrapper {
  width: 100%;
  height: 100%;
  .book-shelf-detail {
    width: 100%;
    height: 100%;
    -webkit-transition: all 0.2s;
    -o-transition: all 0.2s;
    transition: all 0.2s;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    &.books-mobile {
      width: 100%;
      height: 100%;
    }
  }
  .wood-background {
    background-image: url('../assets/imgs/bookshelfdetail/bg-wood.png');
    background-size: cover;
  }
}
.book-top {
  height: 72px;
  top: 0;
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &.wood {
    background: url('../assets/imgs/bookshelfdetail/top-nav.png');
    box-shadow: 0 30px 30px 0 rgba(107, 60, 47, 1);
  }
  &.simple {
    background-color: #c4c4c4;
    box-shadow: 0 10px 20px 0 #8a8a8a;
  }
  .book-top-left {
    position: absolute;
    left: 36px;
    width: 300px;
    height: 100%;
    display: flex;
    // 返回按钮
    .back {
      width: 50px;
      height: 30px;
      margin-top: 22px;
      cursor: pointer;
      img {
        width: 28px;
        height: 28px;
        display: inline-block;
      }
      span {
        font-size: 14px;
        display: inline-block;
        color: #fff;
        margin-right: 5px;
      }
    }
    // 搜索框
    .search-box {
      width: 240px;
      height: 30px;
      display: flex;
      background-size: cover;
      margin-top: 21px;
      border-radius: 14px;
      &.wood {
        background-color: #68351f;
        border: 1px solid #68351f;
      }
      &.simple {
        border: 1px solid #626262;
        background-color: #c4c4c4;
      }
      img {
        width: 21px;
        height: 21px;
        margin: 3.5px 5px 3.5px 7px;
        cursor: pointer;
      }
      .ipt {
        height: 30px;
        margin-left: 12px;
        /deep/.el-input {
          .el-input__inner {
            width: 210px;
            height: 28px;
            padding-left: 5px;
            background: none;
            border: 0;
            outline: none;
          }
          ::-webkit-input-placeholder {
            font-size: 14px;
          }
        }
        &.wood {
          /deep/.el-input {
            .el-input__inner {
              color: #fff;
              &::placeholder {
                color: #fff;
              }
            }
          }
        }
        &.simple {
          /deep/.el-input {
            .el-input__inner {
              color: #626262;
              &::placeholder {
                color: #626262;
              }
            }
          }
        }
      }
    }
  }
  .book-top-center {
    display: flex;
    width: 400px;
    height: 100%;
    .switch-button {
      width: 20px;
      height: 20px;
      cursor: pointer;
      background-size: cover;
      background-repeat: no-repeat;
      margin-top: 25px;

      &.switch-button-left {
        &.wood {
          margin-top: 20px;
          background-image: url('../assets/imgs/bookshelfdetail/switch_left_0.png');
        }
        &.simple {
          margin-top: 25px;
          background-image: url('../assets/imgs/bookshelfdetail/switch_left_1.png');
        }
      }
      &.switch-button-right {
        &.wood {
          margin-top: 20px;
          background-image: url('../assets/imgs/bookshelfdetail/switch_right_0.png');
        }
        &.simple {
          margin-top: 25px;
          background-image: url('../assets/imgs/bookshelfdetail/switch_right_1.png');
        }
      }
    }
    .title-bg {
      width: 400px;
      text-align: center;
      margin: 0 13px;
      background-size: cover;
      background-position: center;
      overflow-x: hidden;
      position: relative;
      &.no-select {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .title {
        font-size: 18px;
        width: 300px;
        white-space: nowrap;
        margin-left: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .scroll-title {
        width: fit-content !important;
        position: absolute; /* 使内部元素的定位相对于容器 */
        left: 20px;
        animation: scrollText 7s linear infinite; /* 应用动画 */
      }
      @keyframes scrollText {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-60%);
        }
      }
      /deep/ .el-select {
        width: 80%;
        height: 100%;
        .el-input {
          height: 100%;
          .el-input__inner {
            height: 100%;
            padding-left: 30px;
            background: none;
            outline: none;
            border: 0;
            font-size: 18px;
            text-align: center;
          }
        }
      }
      &.wood {
        background-image: url('../assets/imgs/bookshelfdetail/title_bg_0.png');
        height: 90%;
        padding-bottom: 10px;
        .title {
          color: #fff;
        }
        /deep/ .el-select {
          .el-input__inner {
            color: #fff;
          }
          .el-icon-arrow-up:before {
            color: #fff;
          }
        }
      }
      &.simple {
        background: #c4c4c4;
        height: 100%;
        padding-bottom: 0;
        .title {
          color: #000;
        }
        /deep/ .el-select {
          .el-input__inner {
            color: #000;
          }
          .el-icon-arrow-up:before {
            color: #000;
          }
        }
      }
    }
  }
  .book-top-right {
    position: absolute;
    right: 36px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    .simple {
      img {
        margin-top: 0;
        cursor: pointer;
        vertical-align: middle;
      }
    }
    .share-book {
      width: 75px;
      height: 30px;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: space-around;
      cursor: pointer;
      .share-book-span {
        font-size: 14px;
        display: inline-block;
        margin-right: 5px;
      }
      .share-book-img {
        width: 18px;
        display: inline-block;
      }
      &.wood {
        background-image: url('../assets/imgs/bookshelfdetail/share-bg@2x.png');
        .share-book-span {
          color: #fff;
        }
      }
      &.simple {
        border: #3f3f3f 1px solid;
        border-radius: 15px;
        .share-book-span {
          color: #3f3f3f;
        }
      }
    }
    .library-login {
      height: 30px;
      padding: 0 10px;
      background-color: #68351f;
      color: #fff;
      line-height: 30px;
      border-radius: 14px;
      cursor: pointer;
      font-size: 14px;
      i {
        margin-right: 5px;
      }
      img {
        width: 18px;
        position: absolute;
        top: 4px;
        margin-right: 5px;
      }
      span {
        margin-left: 25px;
      }
    }
    .simple {
      .library-login {
        background-color: unset;
        border: solid 1px #3f3f3f;
        color: #3f3f3f;
      }
      img {
        margin-top: 0;
        cursor: pointer;
      }
    }
  }
}
#bookCenter {
  padding-top: 44px;
  &.wood {
    background-image: url('../assets/imgs/bookshelfdetail/bg_center_top_0.png');
    background-size: 510px 45px;
    background-repeat: repeat-x;
  }
}
.book-center {
  width: 100%;
  display: flex;
  position: absolute;
  top: 72px;
  height: calc(100% - 120px);
  overflow: auto;
  .book-center-left {
    width: 120px;
    height: 100%;
    background-size: 100% 204px;
    &.wood {
      background-image: url('../assets/imgs/bookshelfdetail/bg_left_0.png');
    }
    &.simple {
      background-image: url('../assets/imgs/bookshelfdetail/bg_left_1.png');
    }
  }
  .book-center-right {
    width: 120px;
    height: 100%;
    background-size: 100% 204px;
    &.wood {
      background-image: url('../assets/imgs/bookshelfdetail/bg_right_0.png');
    }
    &.simple {
      background-image: url('../assets/imgs/bookshelfdetail/bg_right_1.png');
    }
  }
  .book-center-content {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    background-size: 510px 204px;
    &.wood {
      background-image: url('../assets/imgs/bookshelfdetail/bg_center_0.png');
    }
    &.simple {
      background-image: url('../assets/imgs/bookshelfdetail/bg_center_1.png');
    }
    .cfbSon {
      width: 170px;
      height: 204px;
      position: relative;
      .cfbsone {
        width: 160px;
        height: 150px;
        position: absolute;
        bottom: 56px;
        &:focus {
          outline: none;
        }
        .csbsoneSon {
          width: 100%;
          height: 150px;
          position: relative;
          align-items: flex-end;
          display: flex;
          justify-content: center;
          .outer {
            position: relative;
            cursor: pointer;
            height: 150px;
            width: 160px;
            .img-wrapper {
              position: absolute;
              bottom: 0;
              width: 160px;
              display: flex;
              justify-content: center;
              .img-wrapper1 {
                position: relative;
              }
            }
            .imgs {
              position: relative;
              max-height: 150px;
              // max-height: 125px;
              max-width: 160px;
              display: block;
              // object-fit: contain;
              background-repeat: no-repeat;
              background-size: contain;
            }
            .loading {
              width: 30px !important;
              height: 30px !important;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 1;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .adornment {
              position: absolute;
              right: 0;
              top: 0;
              width: 40px;
            }
          }
          &:focus {
            outline: none;
          }
        }
      }
      .cfbstwo {
        width: 160px;
        font-size: 14px;
        align-items: center;
        justify-content: center;
        display: flex;
        color: #6b2d00;
        position: absolute;
        bottom: 40px;
        background: rgba(255, 255, 255, 0.8);
        padding: 0 2px;
        z-index: 4;
        text-align: center;
        max-height: 42px;
        span {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 2;
          word-break: break-all;
        }
      }
      // 横版竖版美观间隙一致
      &:hover .qr {
        display: flex;
      }
      .qr {
        display: none;
        width: 100%;
        height: 100%;
        background: rgba($color: #000000, $alpha: 0.7);
        position: absolute;
        left: 0;
        top: 0;
        justify-content: center;
        align-items: center;
        z-index: 3;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
.book-bottom {
  width: 100%;
  height: 70px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 36px;
  &.wood {
    background-image: url('../assets/imgs/bookshelfdetail/bottom-nav.png');
  }
  &.simple {
    background: #fff;
  }
  .logo-left {
    width: 250px;
    img {
      width: 120px;
      margin-top: 15px;
    }
  }
  .number {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: calc(50% - 30px);
    div {
      width: 60px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #6b2d00;
      background: url('../assets/imgs/bookshelfdetail/rectangle@2x.png') no-repeat;
      background-size: cover;
    }
  }
  .book-bottom-item {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    &.book-bottom-right {
      justify-content: center;
    }
    .button-item {
      min-width: 78px;
      width: fit-content;
      height: 30px;
      display: inline-flex;
      align-items: center;
      border-radius: 14px;
      cursor: pointer;
      padding-right: 8px;
      &.wood {
        color: #fff;
        background-color: #5b2817;
      }
      &.simple {
        border: 1px solid #3f3f3f;
      }
      &.wider {
        min-width: 90px;
      }
      img {
        width: 20px;
        height: 20px;
        margin-left: 8px;
        margin-right: 9px;
      }
      span {
        font-size: 14px;
        line-height: 26px;
        white-space: nowrap;
        display: block;
      }
    }
    .button-collect {
      margin-right: 10px;
    }
    .button-questionaire {
      margin-left: 10px;
    }
    .sort {
      display: flex;
      width: 150px;
      height: 30px;
      cursor: pointer;
      margin-left: 10px;
      .sort-item {
        display: inline-block;
        width: 75px;
        height: 30px;
        line-height: 30px;
        color: #fff;
        font-size: 14px;
        padding-right: 9px;
        cursor: pointer;
        background-size: cover;
      }

      &.wood {
        width: 160px;
        .sort-item {
          width: 80px;

          &.name-sort {
            padding-left: 35px;
            padding-right: 0;
            background-image: url('../assets/imgs/bookshelfdetail/name_normal2.png');
            &.isActiveName {
              background-image: url('../assets/imgs/bookshelfdetail/name_press2.png');
            }
          }
          &.timer-sort {
            padding-left: 37px;
            padding-right: 0;
            background-image: url('../assets/imgs/bookshelfdetail/timer_normal2.png');
            &.isActiveTimer {
              background-image: url('../assets/imgs/bookshelfdetail/timer_press2.png');
            }
          }
        }
      }
      &.simple {
        border: 1px solid #a1a1a1;
        border-radius: 15px;
        position: relative;
        .sort-item {
          text-align: center;
          border-radius: 15px;
          color: #a1a1a1;
          position: absolute;
          height: 28px;
          line-height: 28px;
          padding-right: 0;
          &.timer-sort {
            right: 0;
          }
          &.sort-item-active {
            color: #000;
            background-color: #969696;
            z-index: 1;
          }
        }
      }
    }
  }
}
</style>
<!-- 移动端 -->
<style lang="scss" scoped>
.mobile {
  .mobile-book-top {
    width: 100%;
    height: 50px;
    display: flex;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    .mobile-book-top-left {
      width: 80px;
    }
    .mobile-book-top-center {
      width: 190px;
      text-align: center;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .title-bg {
        width: 100%;
        color: #fff;
        margin: 0;
        background-size: 100% 100%;
        .title {
          font-size: 14px;
          width: 100%;
        }
        /deep/ .el-select {
          .el-input {
            .el-input__inner {
              font-size: 14px;
              font-weight: 700;
            }
            .el-input__icon {
              line-height: normal;
            }
          }
        }
      }
    }
    .mobile-book-top-right {
      display: flex;
      //justify-content: flex-end;
      //gap: 10px;
      width: 61px;
      .button-item {
        width: 26px;
        margin-left: 5px;
      }
    }
    .share-right {
      display: flex;
      justify-content: flex-start;
    }
    .wid-140 {
      width: 140px !important;
    }
    &.wood {
      box-shadow: 0 20px 20px 0 rgba(107, 60, 47, 1);
    }
  }
  .mobile-book-center {
    width: 100%;
    height: calc(100% - 100px);
    position: absolute;
    top: 50px;
    left: 0;
    overflow: auto;
    background-size: 100% 204px;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    flex-direction: column;
    align-items: center;
    .mobile-search {
      background-size: cover;
      min-height: 30px;
      width: 304px;
      background-color: #fff;
      border-radius: 14px;
      margin-top: 20px;
      line-height: 30px;
      text-align: center;
      margin-bottom: 10px;
      img {
        width: 17px;
        vertical-align: middle;
        margin-right: 7px;
      }
      &.wood {
        color: #9e4a2f;
        opacity: 0.7;
      }
    }
    &.simple {
      background-color: #d8d8d8;
    }
    &.wood {
      background-image: url('../assets/imgs/bookshelfdetail/mobile_bg_0.png');
    }
    .mobile-book-center-content {
      width: 100%;
      background-size: 100% 204px;
      &.wood {
        background-image: url('../assets/imgs/bookshelfdetail/mobile_bg_0.png');
      }
      &.simple {
        background-image: url('../assets/imgs/bookshelfdetail/mobile_bg_1.png');
        background-size: 140% 204px;
        background-position-x: center;
      }
      &.mobile-large {
        padding: 0 160px;
        &.wood {
          background-image: url('../assets/imgs/bookshelfdetail/mobile_large_bg_0.png');
        }
        &.simple {
          background-image: url('../assets/imgs/bookshelfdetail/mobile_large_bg_1.png');
        }
      }
      &.mobile-medium {
        padding: 0 160px;
      }

      .mobile-content-center {
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        &.mobile-normal {
          width: 304px;
          .cfbSon:nth-child(even) {
            margin-left: 4px;
          }
        }
        &.mobile-large,
        &.mobile-medium {
          .cfbSon {
            margin-left: 4px;
          }
        }
        .cfbSon {
          width: 150px;
          z-index: 1;
          .cfbsone {
            bottom: 40px;
            width: 140px;
            &:focus {
              outline: none;
            }
          }
          .cfbsone {
            .csbsoneSon {
              .outer {
                width: 140px;
                height: 125px;
                .img-wrapper {
                  width: 140px;
                }
                img.imgs {
                  max-height: 125px;
                  max-width: 140px;
                }
              }
            }
          }
          .cfbstwo {
            width: 140px;
            font-size: 14px;
            align-items: center;
            justify-content: center;
            display: flex;
            color: #6b2d00;
            position: absolute;
            bottom: 26px;
            background: rgba(255, 255, 255, 0.8);
            padding: 0 2px;
            z-index: 4;
            font-size: 14px;
            text-align: center;
            max-height: 42px;
            span {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              -webkit-line-clamp: 2;
            }
          }
        }
      }
    }
  }
  .mobile-book-bottom {
    height: 50px;
    padding: 0 10px;
    position: absolute;
    &.big-screen-detail {
      height: 60px;
    }
    &.simple {
      background-color: #c4c4c4;
    }
    .book-bottom-item {
      width: 80px;
      display: inline-flex;
      align-items: center;
      img {
        width: 71px;
        height: 27px;
      }
      &.book-bottom-right {
        width: 30px;
        img {
          width: 22px;
          height: 22px;
        }
      }
      &__more {
        position: absolute;
        height: fit-content;
        right: 10px;
        bottom: 50px;
        color: #fff;
        background-color: #4e2717;
        padding: 10px 10px 0;
        border-radius: 5px;
        font-size: 14px;
        z-index: 99;
        width: 110px;
        &.en {
          width: 150px;
        }
        li {
          height: 30px;
          line-height: 30px;
          margin-bottom: 4px;
          margin-top: 9px;
          width: fit-content;
          min-width: 50px;
        }
        li:last-of-type {
          .el-divider--horizontal {
            display: none !important;
          }
        }
        li:first-of-type {
          margin-top: 0 !important;
        }
        img {
          width: 14px;
          margin-right: 10px;
          vertical-align: middle;
        }
        &.simple {
          background-color: #3a3a3a;
        }
        .el-divider--horizontal {
          margin: 5px 0 0 20px;
          opacity: 0.7;
          width: 80px;
          pointer-events: none;
        }
        &.en {
          .el-divider--horizontal {
            width: 120px;
          }
        }
      }
    }
    .ml-210 {
      margin-left: 210px;
    }
  }
}
</style>
<style lang="scss">
// TODO main.css 内删除相应样式
.shelfSelectDropdownSimple {
  background-color: #c4c4c4 !important;
  border-color: #c4c4c4 !important;
  .el-select-dropdown__item {
    color: #000;
    // width: 264px !important;
    &.hover {
      background-color: #dedede;
    }
  }
  .el-select-dropdown__empty {
    color: #000;
  }
}
.shelfSelectDropdown {
  background-color: #6b2d00 !important;
  border-color: #6b2d00 !important;
  .el-select-dropdown__item {
    // width: 264px !important;
    color: #fff;
    &.hover {
      background-color: #362116;
    }
  }
  .el-select-dropdown__empty {
    color: #fff;
  }
}
</style>
